<div class="modalDialog">    
	<div>
    <bc-loader sizeLoader="3xl"></bc-loader>
    <h4>Cargando</h4>
	</div>
</div>